import React from 'react';
import { Button } from "react-bootstrap";

import paginationFactory from 'react-bootstrap-table2-paginator';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';

import AuthImage from "../common/AuthImage";

const DesignsList = params => {
    const { SearchBar } = Search;

    function customTotal(from, to, size) {
        return (
            <span className="react-bootstrap-table-pagination-total">
                Showing {from} to {to} of {size} Results
            </span>
        );
    }

    const options = {
        paginationTotalRenderer: customTotal,
        showTotal: true,
        onSizePerPageChange: (sizePerPage, page) => {
            // console.log('Size per page change!!!');
            // console.log('Newest size per page:' + sizePerPage);
            // console.log('Newest page:' + page);
        },
        onPageChange: (page, sizePerPage) => {
            // console.log('Page change!!!');
            // console.log('Newest size per page:' + sizePerPage);
            // console.log('Newest page:' + page);
        }
    };
    const columns = [
        {
            text: '#',
            dataField: 'rowNumber',
            isDummyField: true,
            formatter: indexFormatter,
        },
        {
            text: 'Preview',
            dataField: '_id',
            formatter: previewFormatter,
        },
        {
            text: 'Name',
            dataField: 'name',
            formatter: nameFormatter,
        },
        {
            text: 'Size',
            dataField: 'size',
            formatter: sizeFormatter,
        },
        {
            text: 'Action',
            dataField: 'action',
            isDummyField: true,
            formatter: actionFormatter,
        }
    ]

    function indexFormatter(cell, row, index) {
        return (
            index + 1
        )
    }
    function previewFormatter(cell, row) {
        return (
            <AuthImage 
                src={`${process.env.REACT_APP_FILE_SERVER}/resources/designs/${cell}/thumbnail.png`} 
                className="tableTempPreview" 
                alt={row.name || 'Design preview'}
            />
        )
    }
    function nameFormatter(cell, row) {
        return (
            cell ? cell : 'Untitled'
        )
    }
    function sizeFormatter(cell, row) {
        return cell ? `${cell.width} x ${cell.height}` : '-';
    }
    function actionFormatter(cell, row) {
        return (
            <div className="tableTempActionBox">
                <Button className="tableTempAction" onClick={() => designHandler(row._id)}><i className="material-icons">design_services</i> Design</Button>
                {/* <Button className="tableTempAction" onClick={() => editHandler(cell)}><i className="material-icons">edit</i> Edit</Button> */}
                {/* <Button disabled className="tableTempAction" theme="danger"><i className="material-icons">delete</i> Delete</Button> */}
            </div>
        )
    }
    const designHandler = (designId) => {
        // history.push(`template/${tempId}/edit`);
        
        window.open(
            `${process.env.REACT_APP_DESIGN_EDITOR}/edit/design/${designId}`,
            '_blank',
            'noopener,noreferrer'
        );
    }

    return (
        <ToolkitProvider
            keyField="_id"
            data={params.data ? params.data : []}
            columns={columns}
            search
        >
            {
                props => (
                    <div>
                        <SearchBar {...props.searchProps} />
                        <hr />
                        <BootstrapTable
                            {...props.baseProps}
                            pagination={paginationFactory(options)}
                        />
                    </div>
                )
            }
        </ToolkitProvider>

    )
}

export default DesignsList;
